export default __webpack_public_path__ + "static/media/stage2_documents_3.37124f56.png";